import { DeviceTypes } from 'constants/app';

const detectDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  const isAndroid = /android/.test(userAgent);

  const isiOS = /iphone|ipad|ipod/.test(userAgent);

  const isMac = /macintosh/.test(userAgent);

  const isSafariBrowser = /safari/.test(userAgent) && !/chrome|crios|android/.test(userAgent);

  if (isiOS) {
    return DeviceTypes.IOS;
  }

  if (isMac && isSafariBrowser) {
    return DeviceTypes.IOS;
  }

  if (isAndroid) {
    return DeviceTypes.ANDROID;
  }

  return DeviceTypes.OTHER;
};

export { detectDeviceType };
